import { atom } from 'jotai';
import { ReminderTrigger } from '../typings/reminder';

export const reminderTriggerAtom = atom<ReminderTrigger>({
  open: false,
  reminderId: '',
  chatId: '',
  reminderMessage: '',
  dueAt: '',
  assigneeDetails: [],
  chatMessageId: '',
  createdBy: '',
  createdByName: '',
  phoneNumber: '',
  wabaNumber: '',
  chatName: '',
  chatTypeId: '',
});
